/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectType } from './subjectType.model';
import { SubjectSource } from './subjectSource.model';
import { HouseNumberType } from './houseNumberType.model';


export interface Subjectable { 
    castObce?: string;
    charosKod?: number;
    charosNazev?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    cpCe?: HouseNumberType;
    ico?: string;
    id?: number;
    jmeno?: string;
    lpisId?: number;
    mestskaCast?: string;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    prijmeni?: string;
    psc?: string;
    rodneCislo?: string;
    stat?: string;
    subjectId?: number;
    subjectPartner1?: Subjectable;
    subjectPartner2?: Subjectable;
    subjectSource?: SubjectSource;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
}
export namespace Subjectable {
}


